import { render, staticRenderFns } from "./jsbAdminDownload.vue?vue&type=template&id=39036e9d&scoped=true"
import script from "./jsbAdminDownload.vue?vue&type=script&lang=js"
export * from "./jsbAdminDownload.vue?vue&type=script&lang=js"
import style0 from "./jsbAdminDownload.vue?vue&type=style&index=0&id=39036e9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39036e9d",
  null
  
)

export default component.exports